import React, {useEffect} from 'react'
import Box from '@mui/material/Box'
import Page from '../../components/Page'
import ItemLoader, {RendererProps} from '../../components/ItemLoader'
import useEvaluationSessions from '../../hooks/useEvaluationSessions'
import {EvaluationSessions as EvaluationSessionsWidget} from '../../components/search'
import {getModel} from '../../services/models'
import type {Model as ModelType} from '../../services/types'

export const fetchModel = getModel

const RunsSummary = ({item: model, setItem}: RendererProps<ModelType>) => {
  const {refresh} = useEvaluationSessions()

  useEffect(() => {
    refresh({filters: {models: [model]}})
  }, [model, refresh])

  return (
    <Page title={`${model?.name} runs`} showTitle>
      <Box sx={{m: 3}}></Box>
      <EvaluationSessionsWidget searchbar item_type="model" />
    </Page>
  )
}

const Runs: React.FC = () => {
  const {refresh} = useEvaluationSessions()
  useEffect(() => {
    refresh({})
  }, [refresh])
  return <ItemLoader itemName="model" renderer={RunsSummary} />
}

export default Runs
